import { getQueueLeadsGuessing } from '@/API/repositories/reports';
import { getToday } from '@/common/functions/getToday';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useState, useRef } from 'react';
import moment from 'moment';

const useQueueLeadsGuessingReport = () => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const [data, setData] = useState(null);
	const {
		options: { queuesOptions },
	} = useCommonDataContext();
	const [selectedQueues, setSelectedQueues] = useState([]);
	const { addMessage } = useMessageQueueContext();

	const dateFromRef = useRef();
	const dateToRef = useRef();
	const today = getToday();

	const handleSearch = async (e) => {
		e?.preventDefault();

		setData(() => null);

		if (
			!dateFromRef.current.value ||
			!dateToRef.current.value ||
			selectedQueues?.length === 0
		) {
			addMessage('Fill all fields');
			return;
		}
		const queuesIds = selectedQueues.map((queue) => queue.value._id);
		const payload = {};
		payload.queuesIds = queuesIds;
		payload.creationDateFrom = moment
			.utc(dateFromRef.current.value)
			.startOf('date')
			.toISOString();
		payload.creationDateTo = moment
			.utc(dateToRef.current.value)
			.endOf('date')
			.toISOString();
		const response = await makeRequest(
			getQueueLeadsGuessing.bind(null, payload),
		);

		setData(() => response.data || []);
	};

	const isLoading = hasUnfilledRequest(getQueueLeadsGuessing);

	return {
		data,
		handleSearch,
		isLoading,
		queuesOptions,
		selectedQueues,
		setSelectedQueues,
		dateFromRef,
		dateToRef,
		today,
	};
};

export default useQueueLeadsGuessingReport;
